<app-auth-shell title="Esqueceu a senha?" subtitle="Informe seu e-mail e enviaremos as instruções para redefinir a senha.">
  <form class="auth-login__form" role="form" [formGroup]="formForgot" (ngSubmit)="sendResetLink()">
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input id="email" type="email" formControlName="email" class="auth-field__input" placeholder="nome@empresa.com" autocomplete="email" appFocus />
      </div>
      @if (formForgot.get('email')?.dirty) { @if (formForgot.get('email')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formForgot.get('email')?.hasError('email')) {
      <div class="auth-field__error">E-mail inválido</div>
      } }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formForgot.valid">Enviar link</button>
  </form>
  <p class="auth-login__signup" authShellFooter>Lembrou a senha? <a [routerLink]="['/signin']">Voltar para o login</a></p>
</app-auth-shell>
